import React, { useEffect, useMemo, useState } from 'react';
import Layout from '../../../Layout';
import BreadcrumbBlock from '../../../components/BreadcrumbBlock/BreadcrumbBlock';
import { Link, useLocation } from 'react-router-dom';
import { Button, ConfigProvider, Flex, Input, Pagination, Select, Switch, Table, TableColumnsType, TreeSelect } from 'antd';
import { DeleteOutlined, DownOutlined, EditOutlined, PlusOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import './Agency.scss';
import AddAgencyModal from './AddAgencyModal';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import EditAgencyModal from './EditAgencyModal';
import useToast from '../../../hook/useToast';
import useLoading from '../../../hook/useLoading';
import * as selectOptionsApi from '../../../api/selectOptions/selectOptionsApi';
import { checkDisabledPermission, dataPagination, fommatSelectOption, getUserPermissions } from '../../../until';
import useDebounce from '../../../hook/useDebounce';
import { deleteAgent, getInforAgent, getListAgent, IAgent, LAgent, updateAgent } from '../../../api/agent/AgentApi';
import viVN from 'antd/locale/vi_VN';
import { PaginationProps } from 'antd/es/pagination/Pagination';
import { convertNationwideValueToTree_V2 } from '../../../api/unit/unitApi';
import DrawerAddvance from '../../VehicleManagement/VehicleList/Component/Drawer/DrawerAddvance';
import { dataType } from '../../../services/data';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { NodataTable } from '../../../components/NoDataTable';
import { useSelector } from 'react-redux';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { formatNumber } from '../../../services/mixin';

interface TableDataType {
  key: React.Key;
  codeAgency: string;
  name: string;
  type: number;
  unit: string;
  phoneNumber: string;
  province: string;
  email: string;
  address: string;
  link: string;
}

const dataFilter = {
  idAgent: undefined as undefined | number,
  search: undefined as undefined | string,
  provice: undefined as undefined | number[],
  type: undefined as undefined | number[],
  unit: undefined as undefined | number,
};

const DepartmentUnitAgency: React.FC = () => {
  useEffect(() => {
    gListNationwide()
    getListIProvince()
  }, [])
  const pushToast = useToast();
  const pushLoading = useLoading();
  const location = useLocation();
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, } = getUserPermissions(permissionSlice, location.pathname)

  const [listAgent, setListAgent] = useState<TableDataType[]>([]);
  const [inforAgent, setInforAgent] = useState<IAgent>();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 15, total: 0 });
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditHobbyModal, setShowEditModal] = useState(false);
  const [showDeleteModalAgent, setShowDeleteModalAgent] = useState(false);
  const [dataListNationwide, setDataListNationwide] = useState<any>([]);
  const [isOpenAddvance, setIsOpenAddvance] = useState(false);
  const [datatFilter, setdatatFilter] = useState(dataFilter);
  const [listProvince, setListProvince] = useState<selectOptionsApi.provinceUnit[]>([]);

  // Initialize columns as state
  const [columnDefs, setColumnDefs] = useState<ColDef<any>[]>([
    {
      headerName: 'Hành động',
      field: 'action',
      colId: 'action',
      width: 180,
      resizable: false,
      suppressMovable: true,
      lockPosition: 'left',
      headerComponentParams: {
        template: '<span class="w-full flex items-center justify-center">Hành động</span>'
      },
      cellRenderer: (params: ICellRendererParams) => {
        const { key } = params.data;
        return (
          <div className="h-full d-flex  align-center justify-center gap-10-px">
            <EditOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer   ${checkDisabledPermission(edit)}`}
              onClick={() => gInforAgent(Number(key))}
            />
            <DeleteOutlined
              className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer   ${checkDisabledPermission(isdelete)}`}
              onClick={() => openModalDeleteAgent(Number(key))}
            />
          </div>
        );
      }
    },
    {
      headerName: 'Mã showroom',
      field: 'codeAgency',
      colId: 'codeAgency',
      flex: 1,
    },
    {
      headerName: 'Showroom/Điểm xưởng',
      field: 'name',
      colId: 'name',
      flex: 1,
    },
    {
      headerName: 'Loại hình',
      field: 'type',
      colId: 'type',
      flex: 1,
      cellRenderer: (params: ICellRendererParams) => {
        const { type } = params.data;
        return <div>{type !== null ? dataType[type]?.label : ''}</div>;
      }
    },
    {
      headerName: 'Đơn vị',
      field: 'unit',
      colId: 'unit',
      flex: 1,
    },
    {
      headerName: 'Vùng miền',
      field: 'regionTitle',
      colId: 'regionTitle',
      flex: 1,
    },
    {
      headerName: 'Toàn quốc',
      field: 'nationwideTitle',
      colId: 'nationwideTitle',
      flex: 1,
    },
    {
      headerName: 'Số điện thoại',
      field: 'phoneNumber',
      colId: 'phoneNumber',
      flex: 1,
    },
    {
      headerName: 'Email',
      field: 'email',
      colId: 'email',
      flex: 1,
    },
    {
      headerName: 'Địa chỉ',
      field: 'address',
      colId: 'address',
      flex: 1,
    },
    {
      headerName: 'Link website',
      field: 'link',
      colId: 'link',
      flex: 1,
    }
    ,
    {
      headerName: 'Trạng thái',
      field: 'status',
      colId: 'status',
      // flex: 1,
      minWidth: 205, // Giữ chiều rộng tối thiểu cho cột trạng thái
      cellRenderer: (params: ICellRendererParams) => {
        const { key, status } = params.data;
        return (
          <div className="d-flex align-center gap-10-px white-space-nowrap">
            <Switch
              defaultChecked={!!status}
              onChange={() => updateActiveAgent(Number(key))}
              className={`rs-switch rs-switch--sm   ${checkDisabledPermission(edit)}`}
            />
            <p className="font-medium fw-500 text-344054">
              {selectOptionsApi.activeArray[status ? 1 : 0]}
            </p>
          </div>
        );
      }
    }
  ]);

  const defaultColumnsShow = ['action', 'codeAgency', 'name', 'type', 'unit', 'codeunit', , 'nationwideTitle', 'phoneNumber', 'status'] as any;

  const getListIProvince = async (unitId?: number) => {
    const result = await selectOptionsApi.getProvinceUnit(unitId);
    if (result?.status) {
      setListProvince(result.data);
    } else {
      pushToast(result?.message, 'error', 2000);
    }
  };

  const gInforAgent = async (id: number) => {
    const result = await getInforAgent(id);
    if (result?.status) {
      setShowEditModal(true);
      setdatatFilter({ ...datatFilter, idAgent: id });
      setInforAgent(result.data);
    } else {
      pushToast(result?.message, 'warning', 2000);
    }
  };

  const gListAgent = useDebounce(async (pageCurent: number = 1, pageSize: number = 15) => {
    pushLoading(true);
    const result = await getListAgent(pageSize, pageCurent, datatFilter.provice, datatFilter.unit, datatFilter.type, datatFilter.search);
    if (result?.status) {

      setListAgent(convertData(result.data));
      setPagination({ current: pageCurent, total: result.total, pageSize });
    } else {
      pushToast(result?.message, 'error', 2000);
    }
    pushLoading(false);
  }, 500);

  const convertData = (data: LAgent[]) => {
    const convertData = data.map((item) => ({
      key: item.id,
      codeAgency: item.code,
      name: item.title,
      type: item.type,
      unit: item.unitTitle,
      regionTitle: item.regionTitle,
      phoneNumber: item.phone,
      province: item.provinceTitle,
      email: item.email,
      address: item.address,
      link: item.linkWebsite,
      status: item.view,
      nationwideTitle: item.nationwideTitle
    }));
    return convertData;
  };

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }));
    gListAgent(pageNumber, pageSize);
  };

  const confirmModalAdd = (isSucces: boolean, errorMessage?: string) => {
    if (isSucces) {
      pushToast('Thêm mới showroom thành công', 'success', 2000);
      setShowAddModal(false);
      gListAgent(pagination.current, pagination.pageSize);
    } else {
      pushToast(errorMessage, 'warning', 2000);
    }
  };

  const confirmModalEdit = (isSucces: boolean, errorMessage?: string) => {
    if (isSucces) {
      pushToast('Chỉnh sửa showroom thành công', 'success', 2000);
      setShowEditModal(false);
      gListAgent(pagination.current, pagination.pageSize);
    } else {
      pushToast(errorMessage, 'warning', 2000);
    }
  };

  const openModalDeleteAgent = (id: number) => {
    setdatatFilter({ ...datatFilter, idAgent: id });
    setShowDeleteModalAgent(true);
  };

  const closeModalDeleteAgent = () => {
    setdatatFilter({ ...datatFilter, idAgent: undefined });
    setShowDeleteModalAgent(false);
  };

  const confirmDelete = async () => {
    const result = await deleteAgent(Number(datatFilter.idAgent));
    if (result?.status) {
      pushToast(result?.message, 'success', 2000);
      closeModalDeleteAgent();
      gListAgent(pagination.current, pagination.pageSize);
    } else {
      pushToast(result?.message, 'warning', 2000);
    }
  };

  const gListNationwide = async () => {
    const result = await selectOptionsApi.getAgentListNationwide();
    if (result?.status) {
      setDataListNationwide(convertNationwideValueToTree_V2(result.data));
    } else {
      pushToast(result?.message, 'error', 2000);
    }
  };


  const updateActiveAgent = async (id: number) => {
    const result = await updateAgent(id);
    if (result?.status) {
      gListAgent(pagination.current, pagination.pageSize);
      pushToast(result.message, 'success', 2000);
    } else {
      pushToast(result?.message, 'error', 2000);
    }
  };

  const checkedList = localStorage.getItem('agencyListColums')
    ? JSON.parse(localStorage.getItem('agencyListColums') as string)
    : [...defaultColumnsShow];

  // Sử dụng colId thay vì key
  const columnDefsWithVisibility = useMemo(() => {
    return columnDefs.map((item: any) => ({
      ...item,
      hide: !checkedList.includes(item.colId) // Sử dụng hide property của AG Grid
    }));
  }, [columnDefs, checkedList]);

  const handleCloseSetting = (value: any, isChange: boolean, reorderedColumns: any[]) => {
    if (isChange) {
      localStorage.setItem('agencyListColums', JSON.stringify(value));
      const updatedColumns = reorderedColumns.map((col) => ({
        ...col,
        hidden: !value.includes(col.colId),
      }));
      setColumnDefs(updatedColumns);
    }
    setIsOpenAddvance(false);
  };

  useEffect(() => {
    gListAgent();
  }, [datatFilter]);

  return (
    <>
      <AddAgencyModal
        show={showAddModal}
        confirmModalAdd={confirmModalAdd}
        modalClose={() => setShowAddModal(false)}
      />
      <EditAgencyModal
        show={showEditHobbyModal}
        idAgent={datatFilter.idAgent}
        inforAgent={inforAgent}
        confirmModalEdit={confirmModalEdit}
        modalClose={() => setShowEditModal(false)}
      />
      <ModalDeleteManager
        isOpen={showDeleteModalAgent}
        title="Xóa showroom"
        titleDelete="Xóa"
        content="Showroom và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục"
        closeModal={closeModalDeleteAgent}
        onConfirm={confirmDelete}
      />
      <DrawerAddvance
        isOpen={isOpenAddvance}
        columns={columnDefs}
        defaultColumnsShow={defaultColumnsShow}
        localStorageValue="agencyListColums"
        onClose={(value, isChange, reorderedColumns) => handleCloseSetting(value, isChange, reorderedColumns)}
        closeDrawer={() => setIsOpenAddvance(!isOpenAddvance)}
      />
      <Layout className="customer-hobby">
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link> },
            { title: 'Danh mục đơn vị' },
            { title: 'Showroom/ Điểm xưởng' },
          ]}
          title="Showroom/ Điểm xưởng"
          className="gutter-block-end"
        />
        <Flex vertical className="gap-18px custom-page-css flex flex-col flex-1 ">
          <Flex align="center" className="w-full gap-10px justify-between align-start">
            <span className="fsz-16 font-medium text-nowrap">Danh sách showroom</span>
            <div className="custom-page-css flex-2 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-2-px justify-between overflow-hidden">
              <Input
                placeholder="Tìm kiếm"
                className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
                value={datatFilter.search}
                onChange={(e: any) => setdatatFilter({ ...datatFilter, search: e.target.value })}
              />
              <div className="border-l-F2F4F7 h-full d-flex align-center">
                <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
              </div>
            </div>
            <div className="custom-page-css flex-1 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px justify-between overflow-hidden">
              <div className="d-flex align-center  w-full">
                <Select
                  showSearch
                  allowClear
                  className="w-full text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector "
                  variant="borderless"
                  placeholder="Loại hình"
                  mode="multiple"
                  suffixIcon={null}
                  options={dataType}
                  value={datatFilter?.type}
                  onChange={(e: number[]) => setdatatFilter({ ...datatFilter, type: e })}
                />

              </div>
              <div className="  h-full d-flex align-center">
                <DownOutlined className="text-sm text-98A2B3 " />
              </div>
            </div>
            <div className="custom-page-css flex-1 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px  justify-between overflow-hidden">
              <div className="d-flex align-center w-full">
                <TreeSelect
                  placeholder="Chọn đơn vị"
                  allowClear
                  treeDefaultExpandAll={false}
                  value={datatFilter?.unit}
                  onChange={(e) => setdatatFilter({ ...datatFilter, unit: e })}
                  treeData={dataListNationwide}
                  className="w-full text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select  line-none line-none-item inline-none size-selector"
                  filterTreeNode={(input: string, option: any) =>
                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }

                />
              </div>
            </div>
            {/* <Select
              allowClear
              showSearch={false}
              popupMatchSelectWidth={false}
              mode="multiple"
              placeholder="Chọn thành phố"
              options={fommatSelectOption(listProvince)}
              value={datatFilter?.provice}
              onChange={(e: number[]) => setdatatFilter({ ...datatFilter, provice: e })}
              className="custom-select-mutiple-v2 w-200-px"


            /> */}
            <Button
              type="primary"
              icon={<PlusOutlined />}
              className={`rs-button rs-button--sm   ${checkDisabledPermission(add)}`}
              onClick={() => setShowAddModal(true)}
            >
              Tạo mới
            </Button>
            <button
              className="border-EAECF0 bg-white rounded-2 w-8 h-8 shadow-btn-save"
              onClick={() => setIsOpenAddvance(true)}
            >
              <SettingOutlined className="text-sm text-344054" />
            </button>
          </Flex>
          <div className={`order-history-card__body custom-page-css flex flex-col flex-1 justify-between`}>
            <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
              <AgGridReact
                className="my-auto-height-grid"
                getRowStyle={(params: any) => ({
                  backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                })}
                rowData={listAgent}
                rowHeight={55}
                columnDefs={columnDefsWithVisibility}
                rowSelection={{ mode: 'multiRow' }}
                // rowSelection="multiple"
                overlayNoRowsTemplate={NodataTable}
                suppressDragLeaveHidesColumns={true}
              />

            </div>
            <ConfigProvider locale={viVN}>
              <div className="pagination-block">
                <Pagination showSizeChanger current={pagination.current} pageSize={pagination.pageSize} total={pagination.total}
                  itemRender={(page, type, originalElement) => {
                    // Chỉ custom khi là nút số trang
                    if (type === 'page') {
                      return <span>{formatNumber(page)}</span>;
                    }
                    // prev / next / jump-prev / jump-next giữ nguyên
                    return originalElement;
                  }}
                  showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize,
                    pagination.current).totalPage} trang`}
                  className='rs-pagination'
                  onChange={onPaginationChange}
                />
              </div>
            </ConfigProvider>
          </div>
          {/* <Table
            columns={newColumns.filter((col: any) => !col.hidden)}
            dataSource={listAgent}
            showSorterTooltip={false}
            className="rs-table rs-table--cell-0-padding-block"
            pagination={false}
            scroll={{ x: true }}
          />
          <ConfigProvider locale={viVN}>
            <div className="pagination-block">
            
            </div>
          </ConfigProvider> */}
        </Flex>
      </Layout >
    </>
  );
};

export default DepartmentUnitAgency;
